import { render, staticRenderFns } from "./baidu.vue?vue&type=template&id=1440a289&scoped=true&"
import script from "./baidu.vue?vue&type=script&lang=js&"
export * from "./baidu.vue?vue&type=script&lang=js&"
import style0 from "./baidu.vue?vue&type=style&index=0&id=1440a289&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1440a289",
  null
  
)

export default component.exports